import { DateTimeFactory } from "../../../../../../localization/useDateTime"
import { ClosingTimeType, CreateMobileAVResource, CreateMobileAVResourceForm } from "../../resourcesTypes"

export const transformMobileAVFormToResource = (
    form: CreateMobileAVResourceForm,
    dateTimeFactory: DateTimeFactory,
): CreateMobileAVResource => {
    const { closingTimesDaily, bookingTime, bookingTimeType, ...rest } = form

    const isAcceptBooking = bookingTimeType === "acceptBookingTime"

    const closingTimes = form.closingTimes
        .filter((time) => {
            if (time.type === ClosingTimeType.DAILY) return !isAcceptBooking
            return true
        })
        .map((time) => {
            if (time.type === ClosingTimeType.DAILY && !isAcceptBooking && closingTimesDaily) {
                return {
                    ...time,
                    periodInTime: {
                        from: dateTimeFactory.toHourMinute(closingTimesDaily.periodInTime?.from),
                        to: dateTimeFactory.toHourMinute(closingTimesDaily.periodInTime?.to),
                    },
                }
            }
            return time
        })

    return {
        ...rest,
        closingTimes,
        bookingTime:
            isAcceptBooking && bookingTime
                ? {
                      periodInTime: {
                          from: dateTimeFactory.toHourMinute(bookingTime.periodInTime?.from),
                          to: dateTimeFactory.toHourMinute(bookingTime.periodInTime?.to),
                      },
                  }
                : undefined,
    }
}
